






































import {Mixins, Prop, Watch} from "vue-property-decorator";
import Component from "vue-class-component";
import {Style, Widget} from "@/components/dashboard/Dashboard.vue";
import Container from "@/components/dashboard/widgets/Container.vue";
import DashboardMixin from "@/mixins/dashboard/DashboardMixin";
import {Getter} from "vuex-class";
import Owner from "@/model/cospirit-api/Owner";
import _ from "lodash";
import CarouselItemRepository, {CarouselItem as CarouselItemData} from "@/repositories/CarouselItemRepository";

const components = {
    Container
};

@Component({components})
export default class Carousel extends Mixins(DashboardMixin) {
    @Prop({default: null}) public widget!: Widget;
    @Getter("getCurrentOwner") public currentOwner!: Owner;

    public carouselItems: CarouselItemData[] = [];

    @Watch("currentOwner", { immediate: true })
    protected onCurrentOwnerChange() {
        this.fetchCarousel();
    }

    protected fetchCarousel() {
        const filters = {
            ownerUuid: this.currentOwner.uuid,
            active: true
        };
        CarouselItemRepository.get({filters})
            .then((response: object[]) => {
                if (response.length === 0) {
                    this.carouselItems = [
                        {
                            title: _.invoke(this.$options.filters, "trans", "carouselInComingTitle"),
                        }
                    ];
                    return;
                }
                this.carouselItems = response as CarouselItemData[];
            })
            .catch(() => {
                this.carouselItems = [];
            });
    }

    protected get containerStyle(): Style {
        return {
            padding: 0,
        };
    }

    protected checkActive(event: PointerEvent) {
        const elTarget = event.target as HTMLElement;
        if (!elTarget.closest(".el-carousel__item.is-active")) {
            event.preventDefault();
            return false;
        }
    }

    public manageItemClick(event: PointerEvent) {
        const elTarget = event.target as HTMLElement;
        if (elTarget.closest(".el-carousel__item.is-active")) {
            elTarget.querySelector("a")?.click();
        }
    }
}
